<template>
  <section
    :class="[
				'block-wrapper', 
				componentClass, 
				colorMode, 
        'media-' + data.media_location,
				{
					visible: visible, 
					ready: ready,
				}
			]"
  >
    <div class="row">
      <div class="columns small-12">
        <div :class="['quote-wrapper', data.theme]">
          <figure v-if="data.image">
              <img 
                :src="data.image.src"
                :srcset="data.image.srcset" 
                :alt="data.image.alt"/>
            <figcaption v-if="data.caption" v-html="sanitizedCaption"></figcaption>
          </figure>
          <div class="text-column">
            <svg aria-hidden="true" class="quotemark" xmlns="http://www.w3.org/2000/svg" width="80" height="66" viewBox="0 0 80 66">
            <g fill="none" fill-rule="evenodd">
            <path d="M94.407 66L103 0H79.424L64 61.54V66h30.407zm41 0L144 0h-23.576L105 61.54V66h30.407z" transform="translate(-731 -812) translate(129 812) translate(538)"/>
            </g>
            </svg>
            <div v-html="sanitizedText" :class="[{
              'align-middle' : (data.vertical_align_text==='middle')
            }]"></div>
          </div>
        </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import DOMPurify from 'dompurify';
import BaseBlock from "./Base";

export default {
  extends: BaseBlock,
  data() {
    return {
      defaultColorMode: "light",
      componentClass: "image-and-quote",
    };
  },
  computed: {
    sanitizedCaption() {
      return DOMPurify.sanitize(this.data.caption)
    },
    sanitizedText() {
      return DOMPurify.sanitize(this.data.text)
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/scss/component/image-and-quote";
</style>